import { useMutation } from "react-query";
import { sendRequest } from "../sendRequest";

export const connectIg = async ({ data, token }) => {
  const response = await sendRequest(
    "post",
    "/influencer/social-media-access/instagram/get-eligibility",
    { ...data },
    {
      Authorization: `Bearer ${token}`,
    }
  );
  return response;
};

export default function useConnectIg() {
  return useMutation(connectIg);
}
